import React, { useState } from 'react'
import Markdown from 'react-markdown'
import './ExpandableCard.scss'
import expandIcon from './icons/expand-icon.svg'
import collapseIcon from './icons/collapse-icon.svg'

const ExpandableCard = ({
  title,
  snippet,
  icon,
  children,
  defaultOpen = false,
  additionalOnClick = null,
}) => {
  const [isCardOpen, setIsCardOpen] = useState(defaultOpen)

  const onClick = () => {
    setIsCardOpen(!isCardOpen)
    if (additionalOnClick) additionalOnClick()
  }

  return (
    <div className="ExpandableCard" role="presentation">
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <div className="expandable-card-summary" onClick={onClick}>
        <div className="titles-container">
          {icon && <img src={icon} alt={icon} />}
          <div className="titles">
            <Markdown>{`### ${title}`}</Markdown>
            {snippet && <p>{snippet}</p>}
          </div>
        </div>

        <button
          className="card-toggle"
          type="button"
          aria-expanded={isCardOpen}
        >
          <img
            src={isCardOpen ? collapseIcon : expandIcon}
            alt="expand-section-icon"
          />
        </button>
      </div>
      {isCardOpen && (
        <>
          <hr />
          <div className="expandable-card-details">{children}</div>
        </>
      )}
    </div>
  )
}

export default ExpandableCard
